import { render } from "./FacilityData.vue?vue&type=template&id=453306b6"
import script from "./FacilityData.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/facility/FacilityData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453306b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453306b6', __exports__)) {
    console.log('reload')
    api.reload('453306b6', __exports__)
  }
  
  module.hot.accept("./FacilityData.vue?vue&type=template&id=453306b6", () => {
    console.log('re-render')
    api.rerender('453306b6', render)
  })

}


export default __exports__